// React Modules
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { t, getPriceSavingsInformation } from '@insight/toolkit-utils';
import { Currency } from '../Currency/Currency';
import { connectToLocale } from '../Locale/Locale';

export const ListPrice = ({
  context = {},
  insightPrice,
  labelClassName,
  listPrice,
  indexPrice,
  showListPriceLabel, // Shows for logged in & logged out en_US user
  showSaving,
  strike,
  valueClassName,
  showHorizontalSaveTag,
  showDiscount = false, // Shows for E4 IPS users
  discount = 0,
  ...rest
}) => {
  const nListPrice = indexPrice
    ? Number(indexPrice)
    : listPrice
      ? Number(listPrice)
      : 0;
  const nInsightPrice = insightPrice ? Number(insightPrice) : 0;

  if (!nListPrice || !nInsightPrice) return null;

  const { priceSavings, showListPriceAndSavings, priceSavingsInPercentage } =
    getPriceSavingsInformation(nListPrice, nInsightPrice, showDiscount);

  if (!showListPriceAndSavings) return null;

  const currencyCode = rest.currencyCode
    ? rest.currencyCode
    : context.currencyCode;
  const locale = rest.locale ? rest.locale : context.locale;

  const listPriceClassName = showHorizontalSaveTag ? '' : 'u-1/1';
  const horizontalSave = showHorizontalSaveTag
    ? 'c-list-price__horizontalsave'
    : '';
  const discountClassName =
    showDiscount && priceSavings > 0 ? 'u-text-bold' : '';

  return (
    <div className="c-list-price o-grid u-1/1">
      <div className={cn('c-list-price__price o-grid', listPriceClassName)}>
        {showListPriceLabel ? (
          <span className={cn('c-list-price__price__label', labelClassName)}>
            {indexPrice ? (
              <span>{t('Insight Standard Price:')}</span>
            ) : (
              <span>{t('List price:')}</span>
            )}
          </span>
        ) : null}
        <span className={cn('c-list-price__price__value', valueClassName)}>
          <Currency
            value={nListPrice}
            {...rest}
            currencyCode={currencyCode}
            locale={locale}
            strike={strike}
          />
        </span>
      </div>
      {showSaving ? (
        <div
          className={cn(
            'c-list-price__save',
            horizontalSave,
            discountClassName
          )}
        >
          {t('Save')}{' '}
          <Currency
            value={priceSavings}
            currencyCode={currencyCode}
            locale={locale}
          />
          {showDiscount &&
            priceSavings > 0 &&
            ` (${t('Discount:')} ${priceSavingsInPercentage}%)`}
        </div>
      ) : null}
    </div>
  );
};

ListPrice.propTypes = {
  labelClassName: PropTypes.string,
  listPrice: PropTypes.string.isRequired,
  insightPrice: PropTypes.string.isRequired,
  indexPrice: PropTypes.string,
  context: PropTypes.shape({
    currencyCode: PropTypes.string,
    locale: PropTypes.string,
  }),
  className: PropTypes.string,
  currencyCode: PropTypes.string,
  highlight: PropTypes.bool,
  locale: PropTypes.string,
  render: PropTypes.func,
  showListPriceLabel: PropTypes.bool,
  showSaving: PropTypes.bool,
  showVAT: PropTypes.bool,
  size: PropTypes.oneOf(['', 'large']),
  strike: PropTypes.bool,
  tax: PropTypes.bool,
  valueClassName: PropTypes.string,
};

ListPrice.defaultProps = {
  className: '',
  currencyCode: undefined,
  context: {},
  highlight: false,
  labelClassName: '',
  locale: undefined,
  render: undefined,
  showListPriceLabel: false,
  showSaving: false,
  showVAT: undefined,
  strike: false,
  size: '',
  tax: undefined,
  valueClassName: '',
  showHorizontalSaveTag: false,
};

export default connectToLocale(ListPrice);
